import { render, staticRenderFns } from "./ContactoCuentaPrincipal.vue?vue&type=template&id=ca0ae36c&scoped=true&"
import script from "./ContactoCuentaPrincipal.vue?vue&type=script&lang=js&"
export * from "./ContactoCuentaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ae36c",
  null
  
)

export default component.exports